import script from "./OfProfile.vue?vue&type=script&setup=true&lang=js"
export * from "./OfProfile.vue?vue&type=script&setup=true&lang=js"

import "./OfProfile.vue?vue&type=style&index=0&id=7f037d3b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7f037d3b"]])

export default __exports__